import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ResultForm from './resultForm.react';
import Bricks from './bricks.react';
import Accordion from './accordion.react';

const EXTRA_OFFSET = -20;
const LINK_PREFIX = 'question-';

class ResultPage extends PureComponent {
  static propTypes = {
    hasData: RPT.bool,
    history: RPT.object,
    match: RPT.object,
    questionnaireData: RPT.any,
    rehydrated: RPT.bool,
  }

  state = {
    openedQuestions: [],
    scrollOffset: 0,
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    const {
      hasData,
      history: { push },
      match,
      rehydrated,
    } = nextProps;

    if (!hasData && rehydrated) {
      const backLink = `/${match.params.field_id}/project-health-check`;
      push(backLink);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const scrollOffset = ['header'].reduce(
      (acc, val) => (acc + document.getElementsByClassName(val)[0].getBoundingClientRect().height),
      0,
    ) + EXTRA_OFFSET;

    if (scrollOffset !== this.state.scrollOffset) {
      this.setState({ scrollOffset });
    }
  }

  handleQuestionClick = (questionId, shouldCloseQuestion) => () => {
    const { openedQuestions } = this.state;

    if (openedQuestions.indexOf(questionId) === -1) {
      return this.setState({
        openedQuestions: [...openedQuestions, questionId],
      });
    }

    if (shouldCloseQuestion && openedQuestions.indexOf(questionId) !== -1) {
      return this.setState({
        openedQuestions: openedQuestions.filter(q => q !== questionId),
      });
    }

    return null;
  }

  render() {
    const { questionnaireData } = this.props;
    const { openedQuestions, scrollOffset } = this.state;
    const average = questionnaireData.reduce(
      (acc, cur, index) => (acc + cur.get('result')),
      0,
    ) / questionnaireData.size;

    const percentages = Math.round(average / 4 * 100) || 0;

    const strokeWidth = 9;
    const svgSize = 192;

    const circle = (svgSize - strokeWidth) * 3.14;
    const circleRadius = svgSize / 2;
    const svgRadius = (svgSize - strokeWidth) / 2;
    const offset = (percentages / 100) * circle;
    const dashArray = [offset, circle];

    const circleProgress = {
      strokeWidth,
      strokeDasharray: dashArray,
    };

    return (
      <div>
        <section className="block-questionary block-questionary--result">
          <div className="container">
            <div className="box-l-border">
              <h1>Vyhodnocení auditu GDPR</h1>
            </div>
            <div className="row">
              <div className="col-md-6">
                 <div className="desc">
                  <p>
                    Toto je grafická reprezentace odpovědí na jednotlivě zodpovězené otázky.
                    V oblastech, které dosáhly vysokého hodnocení, bude možné dosáhnout
                    rychlého <a href="/sluzby">souladu s GDPR</a>. Naopak v oblastech s nízkým hodnocením bude
                    nutné provést opravné kroky.
                  </p>

                  <p>
                    V případě vašeho zájmu o detailnější rozbor vašeho výsledku nás prosím
                    <a href="/kontakt">kontaktujte</a>.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="progress-box">
                  <h2>Připravenost vaší společnosti na GDPR</h2>
                  <figure className="circle-progress">
                    <svg
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      width={svgSize}
                      height={svgSize}
                      viewBox="0 0 192 192"
                    >
                      <circle
                        r={svgRadius}
                        fill="none"
                        cx={circleRadius}
                        cy={circleRadius}
                        strokeWidth={strokeWidth}
                        className="circle-progress__background"
                      />
                      <circle
                        r={svgRadius}
                        fill="none"
                        cx={circleRadius}
                        cy={circleRadius}
                        style={circleProgress}
                        className="circle-progress__foreground"
                      />
                    </svg>
                    <div className="circle-progress__inner">
                      <figcaption className="circle-progress__caption">{percentages}<span>%</span></figcaption>
                    </div>
                  </figure>
                </div>
              </div>
            </div>

            <div className="graph">
              {questionnaireData.map((question, index) => <Bricks
                  handleQuestionClick={this.handleQuestionClick}
                  height={question.get('result')}
                  key={question.get('question_id')}
                  label={question.get('label')}
                  link={`${LINK_PREFIX}${index}`}
                  rowIndex={index + 1}
                  scrollOffset={scrollOffset}
                />)}
            </div>
            <ResultForm />

            <Accordion
              data={questionnaireData}
              handleQuestionClick={this.handleQuestionClick}
              linkPrefix={LINK_PREFIX}
              openedQuestions={openedQuestions}
            />
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasData: state.healthCheck.questionnaireData.size > 0,
  questionnaireData: state.healthCheck.questionnaireData,
  rehydrated: state.healthCheck.rehydrated,
});

export default withRouter(
  connect(mapStateToProps)(ResultPage),
);
